import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import TableCell from '@material-ui/core/TableCell';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
//Ícones
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//Componentes
import GenericListPage from './GenericListPage';
import MaskedInput from 'react-text-mask';
//Controller
import EmpresaController from '../controllers/EmpresaController';
//Úteis
import formatarCpfCnpj from '../utils/formatarCpfCnpj';
import { MascaraDocumento } from '../utils/mascara';

/**
 * Componente para listagem de empresas
 */
class EmpresaListPage extends Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handleRenderItem = this.handleRenderItem.bind(this);
        this.handleTipoDocumentoChange = this.handleTipoDocumentoChange.bind(this);
        //Controllers
        this.empresaController = new EmpresaController();
        //Estado inicial
        this.state = {
            nome: '',
            cpfCnpj: '',
            mascaraDocumento: MascaraDocumento['CPF']
        };
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        //Atualiza somente o valor do campo alterado
        state[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState(state);
    }
    
    /**
     * Trata as alteração no tipo de documento
     * @param {*} event Objeto contendo os dados do evento
     */
    handleTipoDocumentoChange(event) {
        //Captura o tipo de documento selecionado
        const tipoDocumento = event.target.value;
        //Identifica a máscara
        const mascaraDocumento = MascaraDocumento[tipoDocumento];
        //Altera o status da página
        this.setState({ tipoDocumento, mascaraDocumento });
    }

    /**
     * Evento disparado para obter os parâmetros do filtros
     * @return {Object} Retorna os parâmetros informados pelo usuário
     */
    handleFilter() {
        //Recupera os parâmetros preenchidos pelo usuário
        const { nome, cpfCnpj } = this.state;
        //Repassa os parâmetros para o filtro
        return { nome, cpfCnpj };
    }

    /**
     * Renderiza um item da lista
     * @param {Object} item Item a ser renderizado
     * @returns {React.Component} Retorna a linha da tabela correspondente
     */
    handleRenderItem(item) {
        return (
            <React.Fragment>
                <TableCell>{item.nome}</TableCell>
                <TableCell>{formatarCpfCnpj(item.cpfCnpj)}</TableCell>
            </React.Fragment>
        );
    }
    
    render() {
        const { onLogout, usuario, empresa, permissoes } = this.props;
        const { nome, cpfCnpj, mascaraDocumento, tipoDocumento } = this.state;
        
        return (
            <GenericListPage resource="empresa" controller={this.empresaController} columnNames={['Nome', 'CPF/CNPJ']} onRenderItem={this.handleRenderItem} onLogout={onLogout} usuario={usuario} empresa={empresa} permissoes={permissoes} onFilter={this.handleFilter} >
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                        <Typography>Filtro</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={5} md={6} >
                                <TextField
                                    name="nome"
                                    label="Nome"
                                    type="text"
                                    placeholder="Nome da empresa"
                                    variant="outlined"
                                    fullWidth
                                    value={nome}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid item xs={4} sm={2} md={2} >
                                <FormControl fullWidth variant="outlined" >
                                    <InputLabel htmlFor="tipo-documento">Tipo documento</InputLabel>
                                    <Select 
                                        id="tipo-documento"
                                        name="tipoDocumento" 
                                        label="Tipo documento"
                                        native 
                                        variant="outlined" 
                                        fullWidth 
                                        value={tipoDocumento} 
                                        onChange={this.handleTipoDocumentoChange} 
                                    >
                                        <option value="CPF">CPF</option>
                                        <option value="CNPJ">CNPJ</option>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8} sm={5} md={4} >
                                <TextField 
                                    name="cpfCnpj" 
                                    label="CPF/CNPJ" 
                                    type="text" 
                                    placeholder="CPF ou CNPJ da empresa" 
                                    variant="outlined" 
                                    fullWidth 
                                    InputProps={{ inputComponent: MaskedInput, inputProps: { mask: mascaraDocumento } }}
                                    value={cpfCnpj} 
                                    onChange={this.handleChange} 
                                />
                            </Grid>
                            <Grid item xs={12} container justify="flex-end" >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                >
                                    Filtrar
                                </Button>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </GenericListPage>
            
        );
    }
}

EmpresaListPage.propTypes = {
    /** Callback executado quando o usuário realiza logout do sistema */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
};

export default EmpresaListPage;